export default [
  {
    path: '/notification/detail',
    name: 'notificationdetail',
    component: () => import('@/views/notification/detail.vue')
  }
]
